
const state = {
  agency_payment_method_id: undefined,
  create_contribution: true,
  in_person: false,
  owner_id: undefined,
  owner_type: '',
  subject_id: undefined,
  subject_type: '',
  total: '',
}

export const requiredFields = [
  { key: 'agency_payment_method_id' },
  { key: 'owner_id' },
  { key: 'owner_type' },
  { key: 'subject_id' },
  { key: 'subject_type' },
  { key: 'total' },
]

export default state
